import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchProjects = () => apiClient.get("/projects").then((r) => r.data);
export const fetchProject = (slug) => apiClient.get(`/projects/${slug}`).then((r) => r.data);
export const submitQuote = (data) => apiClient.post("/quote-request", data).then((r) => r.data);
export const submitContact = (data) => apiClient.post("/contact", data).then((r) => r.data);
